/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "tag": {
    "colors_text": "text-al-korall-700",
    "extend": {
      "variant_text": "uppercase",
      "size_text": "!font-medium"
    }
  },
  "bylines_colors_default": "",
  "bylines_size_default": "gap-2 flex-wrap",
  "bylines_variant_first": "order-5 col-span-2 flex flex-row items-center",
  "bylines_variant_second": "order-4 col-span-3 sm:col-span-1 sm:row-span-2 sm:self-start flex flex-row items-center",
  "bylines_variant_third": "order-6",
  "bylines_variant_fourth": "order-6 col-span-2 sm:col-start-2 flex flex-row items-center",
  "date_colors_default": "text-al-gray-500",
  "date_size_default": "text-al-body-md gap-1 sm:gap-0",
  "date_variant_first": "order-4 self-center flex flex-col sm:flex-row",
  "date_variant_second": "order-6 col-span-2 sm:col-span-1 self-center flex",
  "date_variant_third": "order-7 flex flex-col",
  "date_variant_fourth": "order-3 sm:col-span-2 flex flex-row self-center",
  "category_colors_default": "",
  "category_size_default": "",
  "category_variant_first": "order-3",
  "category_variant_second": "order-5",
  "category_variant_third": "order-4 col-span-2",
  "category_variant_fourth": "order-2 sm:col-start-2",
  "description_colors_default": "",
  "description_size_default": "text-al-preamble",
  "description_variant_first": "order-7 col-span-2 max-w-article-lg mx-auto",
  "description_variant_second": "order-7 col-span-3 sm:col-span-2",
  "description_variant_third": "order-5 col-span-2",
  "description_variant_fourth": "order-5 col-span-2 sm:max-w-article-lg sm:col-start-2",
  "headline_colors_default": "",
  "headline_size_default": "text-al-headline-sm sm:text-al-headline-lg sm:w-3/4",
  "headline_variant_first": "order-2 col-span-2",
  "headline_variant_second": "order-2 col-span-3",
  "headline_variant_third": "order-2 col-span-2",
  "headline_variant_fourth": "order-4 col-span-2 sm:max-w-article-lg sm:col-start-2",
  "image_colors_default": "",
  "image_variant_first": "order-6 col-span-2",
  "image_variant_second": "order-3 col-span-3",
  "image_variant_third": "order-3 col-span-2",
  "image_variant_fourth": "order-1 col-span-2 sm:col-span-4",
  "tags_colors_default": "",
  "tags_size_default": "gap-3",
  "tags_variant_first": "order-1 col-span-2 flex",
  "tags_variant_second": "order-1 col-span-3 flex",
  "tags_variant_third": "order-1 col-span-2 flex",
  "tags_variant_fourth": "order-7 col-span-2 sm:col-start-2 sm:max-w-article-lg flex",
  "colors_default": "",
  "size_default": "max-w-content-lg w-full mx-auto gap-3",
  "variant_first": "grid grid-cols-[auto_1fr]",
  "variant_second": "grid grid-cols-[auto_auto_1fr] sm:grid-cols-[1fr_auto_3fr]",
  "variant_third": "grid grid-cols-[auto_1fr]",
  "variant_fourth": "grid grid-cols-[auto_1fr] sm:grid-cols-[1fr_auto_auto_1fr]",
  "image_size_default": "[&_img]:aspect-default [&_img]:object-cover"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ContentArticleHeader");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;